import { footfallClient } from 'src/clients'
import { TrendsResponse, TrendsPeriod } from 'src/common-services'
import { selector } from 'recoil'
import { DEFAULT_LRU_SIZE, keyFactory, uncachedSelector, uncachedSelectorFamily } from 'src/utils/recoil'
import { venueMatch } from 'src/atoms/search'
import { ifNotFound } from 'src/utils/ajax'
import { trendDatesByPeriod } from 'src/components/insights/common/visits/atoms'
import { venuesInTradeArea } from '.'

export * from './trends-chart'

const key = keyFactory('insights-trade-area-trends-chart')

const monthTrendsForVenue = uncachedSelectorFamily<TrendsResponse | undefined, string>({
  key: key('trend-for-venue'),
  get:
    (venueId) =>
    ({ get }) => {
      const months = get(trendsChartMonths)
      const start = months[0]
      const end = months[months.length - 1]
      if (!start || !end) {
        return undefined
      }
      return ifNotFound(
        footfallClient.getTrends({
          start,
          end,
          period: TrendsPeriod.MONTHLY,
          venueId,
        }),
        undefined
      )
    },
  lru: DEFAULT_LRU_SIZE,
})

export const trendsChartMonths = selector<string[]>({
  key: key('trends-chart-categories'),
  get: ({ get }) => {
    const dates = get(trendDatesByPeriod(TrendsPeriod.MONTHLY)).periods
    const months = dates.slice(-12)
    if (months.length < 3) {
      return []
    }
    return months
  },
})

type TrendsChartSeriesData = {
  name: string
  data: number[]
}
export const trendsChartData = uncachedSelector<TrendsChartSeriesData[]>({
  key: key('trends-chart-data'),
  get: ({ get }) => {
    const venue = get(venueMatch)
    if (!venue) {
      return []
    }
    const venues = get(venuesInTradeArea)
    const nearby = venues.slice(0, 4)
    const ids = [venue.venueId].concat(nearby.map((x) => x.venueId))
    const venueTrends = ids.map((id) => get(monthTrendsForVenue(id)))
    const results: TrendsChartSeriesData[] = []
    for (let i = 0; i < venueTrends.length; i++) {
      const res = venueTrends[i]
      if (res == null) {
        continue
      }
      const name = i === 0 ? venue.brand ?? 'venue' : venues[i - 1].brand

      results.push({
        name,
        data: res.map((x) => x.personCountSum),
      })
    }
    return results
  },
  lru: DEFAULT_LRU_SIZE,
})
